const myText = `
    <style>
      .my-custom-body {
          font-family: 'AkzidenzGroteskStd-Light';
          font-size: 12pt;
          letter-spacing: 0.75pt;
          line-height: 1.4;
          padding: 50px;
      }
      .my-custom-body p{
        font-family: 'AkzidenzGroteskStd-Light';
        font-size: 12pt;
        text-align:left;
    }
      .my-custom-body header {
          font-family: 'AkzidenzGroteskStd-Md';
          font-size: 25pt;
          letter-spacing: 0.5pt;
          line-height: 1;

      }
      .my-custom-body sub {
          font-family: 'AkzidenzGroteskStd-Md';
          font-size: 15pt;
          letter-spacing: 0.5pt;
          line-height: 1.1;

      }
      .my-custom-body small {
          font-family: 'AkzidenzGroteskStd-Light';
          font-size: 9pt;
          letter-spacing: 0.75pt;
          line-height: 1;
      }
    </style>
    <div class="my-custom-body">
        <header>Medicinskt samtycke</header>
        <p><small>Giltig fr&aring;n 21 December 2018</small><br></p>
        <br>
        <hr>
        <br>
        <sub>Healo &auml;r utformad f&ouml;r att hj&auml;lpa dig att uppn&aring; sm&auml;rtlindring genom egenv&aring;rd av muskuloskeletala sjukdomar.<br>
        <br>Healo ers&auml;tter inte professionell medicinsk r&aring;dgivning.</sub><br>
        <br>
        <hr>
        <br>
        <sub>1 &nbsp;&nbsp;Healo</sub><br>
        <br>Healo &auml;r en CE-m&auml;rkt applikation (&ldquo;App&ldquo; och &ldquo;Appen&ldquo;) f&ouml;r sm&auml;rtlindring genom egenv&aring;rd som tillg&auml;ngligg&ouml;rs av Empowered Applications AB, organisationsnummer 559093&ndash;0722.<br>
        <br>Allt inneh&aring;ll i appen, inklusive text, bilder, ljud eller andra format, &auml;r skapad f&ouml;r informations&auml;ndam&aring;l endast. V&auml;nligen notera att informationen som presenteras i Appen inte ger dig r&aring;d om medicinska problem.<br>
        <br>Genom att forts&auml;tta och anv&auml;nda Appen, bekr&auml;ftar du och godk&auml;nner denna juridiska ansvarsfriskrivning, som &auml;ndras fr&aring;n tid till annan.<br>
        <br>
        <br>
        <sub>2 &nbsp;&nbsp;Medicinsk information</sub><br>
        <br>Appen tillhandah&aring;ller utvald information om tr&auml;ningsprogram f&ouml;r egenv&aring;rd och individualiserat behandlingsst&ouml;d. &Ouml;vningsprogrammen och behandlingsst&ouml;det genereras automatiskt baserat p&aring; din Sj&auml;lvskattning. &Ouml;vningar och behandlingsst&ouml;d &auml;r inte skr&auml;ddarsydda f&ouml;r dig av medicinsk professionell och kan vara ol&auml;mpliga f&ouml;r dina specifika omst&auml;ndigheter. Endast v&aring;rdpersonal kan avg&ouml;ra om ett egenv&aring;rdsprogram i Appen &auml;r l&auml;mpligt f&ouml;r dig.<br>
        <br>Om du har eller tror att du har h&auml;lsoproblem eller skador som kan f&ouml;rv&auml;rras av &ouml;vningarna i Healo b&ouml;r du kontakta v&aring;rdpersonal innan du agerar p&aring; rekommendationerna i Appen. Bortse aldrig fr&aring;n professionell medicinsk r&aring;dgivning eller dr&ouml;j med av att s&ouml;ka hj&auml;lp p&aring; grund av information fr&aring;n Appen. Du &auml;r ansvarig f&ouml;r att du g&ouml;r &ouml;vningarna p&aring; ett s&auml;kert s&auml;tt och i enlighet med instruktionerna fr&aring;n Appen.<br>
        <br>
        <br>
        <sub>3 &nbsp;&nbsp;Ansvarsfriskrivning</sub><br>
        <br>All information och allt material som &auml;r relaterat till Appen tillhandah&aring;lls &ldquo;as is&ldquo; och kan &auml;ndras utan f&ouml;reg&aring;ende meddelande. I den utstr&auml;ckning som till&aring;ts enligt g&auml;llande lag ger Empowered Applications ingen garanti om fullst&auml;ndigheten, noggrannheten, aktualiteten, tillr&auml;ckligheten, l&auml;mpligheten, funktionaliteten, tillg&auml;ngligheten eller driften av Appen och den information och de material som den inneh&aring;ller. Genom att anv&auml;nda Appen godtar du risken att informationen och materialen i Appen kan vara ofullst&auml;ndiga, felaktiga, f&ouml;r&aring;ldrade eller kanske inte uppfyller dina behov och krav. Empowered Applications fr&aring;nskriver sig alla garantier, uttryckta eller underf&ouml;rst&aring;dda, inklusive, men inte begr&auml;nsat till, garantierna eller s&auml;ljbarheten, l&auml;mpligheten f&ouml;r syftet och &ouml;vertr&auml;delse med avseende p&aring; information, grafik och material som &auml;r relaterade till Appen.<br>
        <br>
        <br>
        <sub>4 &nbsp;&nbsp;Ansvarsbegr&auml;nsning</sub><br>
        <br>Alla anv&auml;ndare samtycker om att tillg&aring;ng till och anv&auml;ndning av Appen sker p&aring; egen risk och att varken Empowered Applications eller n&aring;gon part som &auml;r inblandad i att skapa eller leverera Appen, i den omfattning som till&aring;ts enligt g&auml;llande lag, ska h&aring;llas ansvarig f&ouml;r skador av n&aring;got slag, inklusive, utan begr&auml;nsning, direkta eller indirekta, oavsiktliga eller f&ouml;ljdskador som uppst&aring;r p&aring; grund av tillg&aring;ng till eller anv&auml;ndning av informationen i Appen, eller eventuella fel eller utel&auml;mnanden, felstavningar, f&ouml;r&aring;ldrad information, tekniska eller prism&auml;ssiga felaktigheter, defekter, f&ouml;rdr&ouml;jning i data&ouml;verf&ouml;ring, datavirus eller andra fel som visas i Appen.<br>
        <br><br>
        <hr>
        <br><br>
        <sub>Uppgiftsskyddsombud</sub><br>
        <br>F&ouml;r mer information eller vid fr&aring;gor om denna Medicinska ansvarsfriskrivning v&auml;nligen kontakta HEALOs <em>Uppgiftsskyddsombud</em>:<br>
        <br><sub><a href="mailto:core@healo.app?Subject=Till Healos Uppgiftsskyddsombud" target="_top">core@healo.app</a></sub><br>
        <br>
		    Empowered Applications AB<br>
        559093&ndash;0722<br>
        <br>Stora gr&aring;br&ouml;dersgatan 13<br>
        222 22 Lund<br>
        <br>
        <hr>
        <p><small><strong>Healo</strong> &auml;r ett registrerat varum&auml;rke av<br>
        Empowered Applications &copy;2017&ndash;18</p>
    </div>`;
export default myText;



// WEBPACK FOOTER //
// ./src/common/consents/clinical_info_swe_andr.js